import React, { useEffect, useState } from "react";
import axios from "axios";
import "./SongList.css";

const SongList = () => {
  const [songs, setSongs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [displayedCount, setDisplayedCount] = useState(12); // Show 12 songs initially on mobile
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const GOOGLE_SHEET_ID = "12tZ7o-BYgtTqfIPXaO7UwsxkkGa3YMLb6cIEqvRf8gs";
  const SHEET_NAME = "Sheet1";

  // Handle window resize to detect mobile
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const fetchSongs = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `https://opensheet.vercel.app/${GOOGLE_SHEET_ID}/${SHEET_NAME}`
        );
        
        console.log("Raw data from sheet:", response.data);
        
        // Get the first row to determine column names
        if (response.data.length === 0) {
          setSongs([]);
          setError(null);
          return;
        }
        
        // Get all keys from first row to see what columns we have
        const firstRow = response.data[0];
        const columnKeys = Object.keys(firstRow);
        console.log("Column keys:", columnKeys);
        
        // Determine which columns contain song name and artist
        // OpenSheet might use keys like "Song Name", "Artist Name" or lowercase variants
        const songNameKey = columnKeys.find(
          (key) => key.toLowerCase().includes("song") || key.toLowerCase() === "a"
        );
        const artistNameKey = columnKeys.find(
          (key) => key.toLowerCase().includes("artist") || key.toLowerCase() === "b"
        );
        
        console.log("Song name key:", songNameKey, "Artist name key:", artistNameKey);
        
        // Filter out empty rows and map to song objects
        const songData = response.data
          .filter((row) => row[songNameKey] && row[artistNameKey])
          .map((row) => ({
            songName: row[songNameKey],
            artistName: row[artistNameKey],
          }));
        
        console.log("Processed song data:", songData);
        setSongs(songData);
        setError(null);
      } catch (err) {
        console.error("Error fetching song list:", err);
        setError("Failed to load song list. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchSongs();
  }, []);

  return (
    <section id="song-list" className="song-list uk-section">
      <div className="container--min uk-container">
        <h2 className="uk-h2 uk-margin-bottom">Song List</h2>

        {loading && <p>Loading songs...</p>}
        {error && <p className="uk-text-danger">{error}</p>}

        {!loading && songs.length > 0 && (
          <>
            <div className="song-list-grid">
              {songs
                .slice(0, isMobile ? displayedCount : songs.length)
                .map((song, index) => (
                  <div key={index} className="song-item">
                    <h3 className="song-item__title">{song.songName}</h3>
                    <p className="song-item__artist">{song.artistName}</p>
                  </div>
                ))}
            </div>
            {isMobile && displayedCount < songs.length && (
              <button
                className="load-more-btn"
                onClick={() => setDisplayedCount(displayedCount + 12)}
              >
                Load More
              </button>
            )}
          </>
        )}

        {!loading && songs.length === 0 && (
          <p>No songs found in the list.</p>
        )}
      </div>
    </section>
  );
};

export default SongList;
